import { AuthLayout, LoginForm } from '../components';
import Homescreen_icon from '../../home/assets/Homescreen.png';
import { AUTH_SUBTITLE_CLASS, AUTH_TITLE_CLASS } from '../lib/authStyles';

export function LoginPage() {
  return (
    <AuthLayout rightImage={Homescreen_icon} rightAlt="Aexon Assistant Mockup">
      <h1 className={AUTH_TITLE_CLASS}>Welcome Back</h1>
      <h2 className={AUTH_SUBTITLE_CLASS}>Sign in to continue to Aexon</h2>

      <div className="animate-fadeIn">
        <LoginForm />
      </div>
    </AuthLayout>
  );
}
